const BASE_PACKAGE_AMOUNTS = [20, 50, 100, 300, 500, 1000, 2000, 3000, 5000];

export const buildPackageAmounts = (...additionalAmountLists) => {
  const amounts = BASE_PACKAGE_AMOUNTS.slice();

  additionalAmountLists.forEach((amountList) => {
    (amountList || []).forEach((amount) => {
      const numericAmount = Number(amount);
      const isUsable =
        Number.isFinite(numericAmount) &&
        numericAmount > 0 &&
        !amounts.includes(numericAmount);

      if (isUsable) {
        amounts.push(numericAmount);
      }
    });
  });

  return amounts.sort((first, second) => first - second);
};
